module.exports = __webpack_public_path__ + "img/logo-expocafe.06b0b298.png";